export default __webpack_public_path__ + "static/media/portugalIcon.82b32484.svg";